// extracted by mini-css-extract-plugin
module.exports = {"forbidden":"_403_forbidden_2ylHt"};